import { sendToApi } from 'api/client'

interface ReferralUrlData {
  promotions: {
    referral_link: string
  }[]
}

export const ReferralsClient = {
  getReferralUrl: () => {
    return sendToApi<ReferralUrlData>(`/referrals`, {
      method: 'get',
    })
  },
  createReferralUrl: () => {
    return sendToApi<ReferralUrlData>(`/referrals`, {
      method: 'POST',
    })
  },
  sendReferralEmail: (emails: string[], referralUrl: string) => {
    return sendToApi(`/referrals/send_emails`, {
      method: 'POST',
      body: { emails, referral_url: referralUrl },
    })
  },
}
